<template>
  <v-container>
    <v-row>
      <v-col :cols="12" v-if="!$store.state.account.subscribed" >
        <v-alert type="warning" class="mt-2 float-end">
          <span>You aren't subscribed.</span>
          <v-btn @click="$router.push({
        path: '/account',
        query: {
          subscribe: true
        }
        })"
                 color="primary"
                 class="text-none ml-2 mr-2">Subscribe</v-btn>
          <span>to get started.</span>
        </v-alert>
        <div class="d-flex align-center justify-center" style="width: 100%;">

        </div>
      </v-col>
      <v-col :cols="12" v-else-if="loadingVideos" class="d-flex align-center flex-column">
        <v-progress-circular indeterminate color="primary" />
      </v-col>
      <template v-if="!loadingVideos && videos.length === 0">
        <v-col :cols="12">
          <div style="width: 100%" class="d-flex justify-center align-center">
            <v-alert type="info" class="mt-2 float-md-end">
              You haven't uploaded any videos yet!  Once you do they'll appear below.
              <br />
              <v-btn text color="primary" to="learn">Show me how</v-btn>
            </v-alert>
          </div>
        </v-col>
        <v-col :cols="12" :sm="6" :lg="4" :xl="3" v-for="i in [1, 2, 3, 4]" :key="i">
          <v-skeleton-loader class="mx-auto" type="card" />
        </v-col>
      </template>
      <template v-else-if="!loadingVideos">
        <v-col :cols="12">
          <div class="text-h4 pt-10">Your Torvue Tours</div>
        </v-col>
        <v-col  :cols="12" :sm="6" :lg="4" :xl="3" v-for="v in videos" :key="v.videoId">
          <v-card elevation="5">
            <v-card-title class="text-break">
              {{v.name}}
            </v-card-title>
            <v-card-subtitle>
              {{v.dateTimeString}}
            </v-card-subtitle>
            <v-card-text>

              <v-row class="d-flex">
                <v-col :cols="12">
                  <v-img v-if="v.thumbnailUrl" :src="v.thumbnailUrl" @click="openVideo(v.mlsUrl || v.brandedUrl)" style="cursor: pointer;" />
                  <v-skeleton-loader v-else type="image" />
                  <v-btn block @click="openVideo(v.mlsUrl || v.brandedUrl)" color="primary">
                    View Tour
                  </v-btn>
                </v-col>
                <v-col :cols="6" :sm="12" :md="6" class="d-flex">
                  <v-btn v-if="v.brandedUrl" text small color="secondary" class="text-none ml-auto" @click="copyToClipboard(v.brandedUrl)">
                    <v-icon class="mr-1">mdi-content-copy</v-icon>
                    Copy Link
                  </v-btn>
                </v-col>
                <v-col :cols="6" :sm="12" :md="6" class="d-flex">
                  <v-btn v-if="v.mlsUrl" text small color="secondary" class="text-none ml-auto" @click="copyToClipboard(v.mlsUrl)">
                    <v-icon class="mr-1">mdi-content-copy</v-icon>
                    Copy MLS Link
                  </v-btn>
                </v-col>
                <v-col :cols="6" :sm="12" :md="6" class="d-flex">
                  <v-btn text small color="secondary" class="text-none ml-auto" @click="copyEmbedCode(v)">
                    <v-icon class="mr-1">mdi-code-braces</v-icon>
                    Copy Embed Code
                  </v-btn>
                </v-col>
                <v-col :cols="6" :sm="12" :md="6" class="d-flex">
                  <v-btn text small color="secondary" class="text-none ml-auto" @click="downloadQrCode(v)">
                    <v-icon class="mr-1">mdi-qrcode</v-icon>
                    Download QRCode
                  </v-btn>
                </v-col>
                <v-col v-if="isLocal" :cols="6" :sm="12" :md="6" class="d-flex">
                  <v-btn text small color="secondary" class="text-none ml-auto" @click="copyVideoJson(v)">
                    <v-icon class="mr-1">mdi-qrcode</v-icon>
                    Copy Video JSON
                  </v-btn>
                </v-col>
<!--                <v-col v-if="v.analyticsInteractionTime > 0" :cols="12">-->
<!--                  Loaded {{v.analyticsPageLoaded}}-->
<!--                  Started: {{v.analyticsTourStarted}}-->
<!--                  Minutes watched: {{Math.round(v.analyticsInteractionTime / 60)}}-->
<!--                </v-col>-->
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="deleteVideo(v)" class="ml-2" color="warning"
                     :disabled="v.deleting"
                     :loading="v.deleting"
              >
                <v-icon class="mr-1">mdi-delete</v-icon>
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import Api from '@/services/aws/Api'
import Utils from "@/services/Utils"
import QrCodeGenerator from "@/services/QrCodeGenerator"

export default {
  name: 'Home',
  components: {

  },
  data() {
    return {
      isLocal: process.env.VUE_APP_LOCAL === 'true',
      loadingVideos: true,
      videos: []
    }
  },
  methods: {
    async downloadQrCode(v) {
      await QrCodeGenerator.generateQrCode(v.brandedUrl || v.mlsUrl, v.name)
    },
    copyVideoJson(v) {
      const str = JSON.stringify(v, null, 2)

      navigator.clipboard.writeText(str)
      this.$swal({
        title: 'Copied to clipboard!',
        timer: 1500,
        toast: true,
        position: 'top-right',
        timerProgressBar: true,
        // icon: 'success',
        showConfirmButton: false,
        showCancelButton: false
      })
    },
    copyEmbedCode(v) {
      const url = v.brandedUrl || v.mlsUrl

      // const str = `<iframe src="${url}" title="${v.name}" width="315" height="516" frameborder="0" allow="autoplay" allowfullscreen></iframe>`
      const str = `<a href="${url}" target="_blank"><img src="${v.thumbnailUrl}" width="810" height="405" alt="${v.name}" /></a>`

      navigator.clipboard.writeText(str)
      this.$swal({
        title: 'Code copied to clipboard!',
        timer: 1500,
        toast: true,
        position: 'top-right',
        timerProgressBar: true,
        // icon: 'success',
        showConfirmButton: false,
        showCancelButton: false
      })
    },
    copyToClipboard(str) {
      navigator.clipboard.writeText(str)
      this.$swal({
        title: 'Link copied to clipboard!',
        timer: 1500,
        toast: true,
        position: 'top-right',
        timerProgressBar: true,
        // icon: 'success',
        showConfirmButton: false,
        showCancelButton: false
      })
    },
    async deleteVideo(video) {
      try {
        video.deleting = true

        const answer = await this.$swal({
          title: `Delete ${video.name}?`,
          text: `Are you sure you'd like to delete this video?  It's permanent.  Once deleted it can't be recovered.`,
          showDenyButton: true,
          reverseButtons: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'Cancel'
        })

        if(answer.isConfirmed) {
          this.loadingVideos = true

          //This is a hack... right now if the video is too big, it takes > 30s to delete all the files so then the API Gateway request times out.
          //  The hack below will repeatedly call deleteVideo 20 times, ignoring all errors.  It should be able to delete all files in that time frame.
          for(let c = 0; c < 20; c++) {
            try{
              let result = await Api.deleteVideo(this.$store.state.credentials, video.videoId)
              console.log(`success = ${result}`)
              break
            } catch(e) {
              console.log(e)
            }
          }

          await Utils.sleep(2000)
          await this.init()
        }
      } catch(e) {
        console.log(e)
        await this.$swal(e.toString())
        window.location.reload()
      } finally {
        video.deleting = false
      }
    },
    openVideo(url) {
      window.open(url)
    },
    async init() {
      try {
        this.loadingVideos = true
        const response = await Api.getVideos(this.$store.state.credentials)
        for(let v of response.data.videos) {
          v.dateTimeString = new Date(v.captureTime).toLocaleString()
        }
        this.videos = response.data.videos
      } catch(e) {
        console.log(e)
        this.$swal('An error occurred requesting your videos. If this repeatedly occurs, contact support@torvue.com.')
        window.location.reload()
      } finally {
        this.loadingVideos = false
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>
<style scoped>

</style>
